<template>
  <div>
    <SignDialog ref="dialog" />
    <Scroll ref="scroll" :class="$style.wrapper">
      <div :class="$style.content">
        <!-- 首页签到部分 -->
        <section id="sign" :class="$style.sign">
          <div :class="$style['sign-content']" ref="signGift">
            <!-- 绑定账号 -->
            <div :class="$style.account">
              <p v-if="isBindAccount">
                欢迎您，<span>{{ userInfo.game_account }}</span>
              </p>
              <p v-else @click="bindAccount()">您还没有绑定账号，<span>点击此处绑定</span></p>
            </div>
            <div :class="$style['sign-gift']">
              <p>您已累计签到{{ totalNumber }}天</p>
              <div :class="$style['btn-wrapper']">
                <img :src="lotteryBtn" @click="clickLottery" />
                <img :src="signBtn" @click="clickSign" />
              </div>
              <div :class="$style['sign-rule']">
                <p>首次签到即可领取游戏内豪华大礼包</p>
                <p>累计签到<span style="color: #ffb428">3天</span>可抽取实物大奖</p>
                <p>累计签到<span style="color: #ffb428">5天</span>可抽取实物大奖</p>
              </div>
              <img :class="$style.down" :src="downIcon" @click="goToDown" />
            </div>
          </div>
        </section>
        <CircleBaseBox :class="$style.gift" boxTitle="可领取礼包">
          <!-- 没有绑定账号时显示部分 -->
          <div v-if="!isBindAccount" :class="$style['no-bind']">
            <p>您还未绑定任何游戏账号</p>
            <div @click="bindAccount">点击前往绑定</div>
            <img :src="catBack" alt />
          </div>
          <!-- 绑定账号但激活游戏没有对应礼包时显示 -->
          <div v-if="isBindAccount && giftListLength == 0" :class="$style['no-bind']">
            <p>
              &nbsp;对不起，您的游戏未参与本次活动，
              <br />您可以选择下方推荐游戏的礼包哟~
            </p>
            <img :src="catBack" alt />
          </div>
          <!-- 绑定账号且激活游戏且有对应礼包时显示 -->
          <div v-if="isBindAccount && giftListLength > 0" :class="$style['gift-list']">
            <SignGiftList
              :swiperList="giftList"
              :totalNumber="totalNumber"
              @scrollToSign="scrollToSign"
            />
          </div>
        </CircleBaseBox>
        <CircleBaseBox boxTitle="其他游戏礼包推荐">
          <SignRecGiftList :swiperList="recommendGiftList" />
        </CircleBaseBox>
        <CircleBaseBox id="lottery" boxTitle="签到抽奖领壕礼">
          <SignLottery :lotteryList="lotteryList" :lotteryTimes="lotteryTimes" />
        </CircleBaseBox>
        <CircleBaseBox boxTitle="活动规则">
          <div :class="$style.rules">
            <p>1、微信用户在此页面绑定游戏账号后，即可参与本次活动，游戏账号绑定后不可更改。</p>
            <p>
              2、每个绑定的游戏账号在此页面累计签到达到3天、5天，可各获得一次抽取实物大奖的机会。本次活动每位玩家最多可获得2次抽奖机会。
            </p>
            <p>
              3、每个绑定的游戏账号，可领取已激活的、参与此次活动的游戏的限量礼包一份，领完即止。
            </p>
            <p>
              4、用户可在抽奖记录中查询自己的中奖信息。若抽到实物奖励，请及时填写收货信息，中奖后7天内未填写收货信息，则视为自动放弃领奖。
            </p>
            <p>5、本次活动解释权归官方所有。</p>
          </div>
        </CircleBaseBox>
      </div>
    </Scroll>
  </div>
</template>

<script>
import SignDialog from './components/SignDialog';
import Scroll from '_c/Scroll';
import CircleBaseBox from '_c/CircleBaseBox';
import SignGiftList from './components/SignGiftList';
import SignRecGiftList from './components/SignRecGiftList';
import SignLottery from './components/SignLottery';
import { getSignTimes, getGiftList, geRewardList, userSignIn } from '@/api/activity';
import { Dialog } from 'vant';
import { mapActions, mapState, mapMutations } from 'vuex';
import { CDN_URL } from "@/config/index.js";
export default {
  components: {
    SignDialog,
    Scroll,
    CircleBaseBox,
    SignGiftList,
    SignRecGiftList,
    SignLottery,
    Dialog
  },
  data() {
    return {
      downIcon: `${CDN_URL}/sign_gift_act/down.png`,
      catBack: `${CDN_URL}/catBack.png?v=123`,
      lotteryBtn: `${CDN_URL}/sign_gift_act/button_01.png`,
      signBtn: `${CDN_URL}/sign_gift_act/button_02.png`,
      totalNumber: 0, // 累计签到次数
      signClickFlag: false, // 签到按钮防重复点击
      gameGiftFlag: false,
      giftList: [], // 可领取礼包列表
      recommendGiftList: [], // 推荐礼包列表
      lotteryList: [], // 奖品列表
      lotteryTimes: 0, // 剩余抽奖次数
    };
  },
  computed: {
    ...mapState("account", {
      userInfo: state => state.userInfo // 当前用户信息
    }),
    // 活动id
    activityId() {
      return Number(this.$route.query.activityId)
    },
    // 判断是否绑定游戏账号
    isBindAccount() {
      let flag = this.userInfo.game_user_id != 0 ? true : false
      return flag;
    },
    // 可领取礼包长度
    giftListLength() {
      return this.giftList.length
    }
  },
  created() {
    this.getSignTimes()
    this.getGiftList()
    this.geRewardList()
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING',
      CHANGE_BIND_GAME: 'CHANGE_BIND_GAME'
    }),
    // 获取累计签到次数
    async getSignTimes() {
      try {
        const r = await getSignTimes({
          lucky_draw_id: this.activityId,
        })
        this.totalNumber = r.data.total_sign_in_times;
        this.lotteryTimes = r.data.surplus_luck_draw_times;
      } catch (error) {
        // 报错跳转到游戏中心
        if (error.code == -1) {
          Dialog.alert({
            title: '温馨提示',
            message: error.message,
          }).then(() => {
            this.$router.push({ name: "gameCenter.home" });
          })
        } else {
          console.log(error);
        }
      }
    },
    // 获取可领取礼包列表/推荐礼包列表
    async getGiftList() {
      const r = await getGiftList({ lucky_draw_id: this.activityId });
      this.giftList = [...r.data.can_get_gifts];
      this.recommendGiftList = [...r.data.recommend_gifts];
    },
    // 获取奖品列表
    async geRewardList() {
      const r = await geRewardList({ lucky_draw_id: this.activityId });
      this.lotteryList = [...r.data];
      this.lotteryList.length != 0 && this.lotteryList.splice(4, 0, { icon: `${CDN_URL}/sign_gift_act/gift_button.png` })
    },
    // 绑定账号
    bindAccount() {
      this.CHANGE_BIND_GAME(true)
    },
    // 点击抽奖按钮
    clickLottery() {
      if (!this.isBindAccount) {
        this.bindAccount()
        return
      }
      if (!this.lotteryTimes) {
        this.$refs.dialog.showDialog('canNotLottery')
        return
      }
      this.$refs.scroll.scrollToElement(document.querySelector('#lottery'))
    },
    // 点击签到按钮
    async clickSign() {
      if (!this.isBindAccount) {
        this.bindAccount()
        return
      }
      if (this.signClickFlag) return
      this.signClickFlag = true
      this.CHANGE_SHOW_LOADING(true)
      try {
        const r = await userSignIn({
          lucky_draw_id: this.activityId
        })
      } catch (error) {
        this.$refs.dialog.showDialog('canNotSign')
        this.signClickFlag = false
        return
      } finally {
        this.CHANGE_SHOW_LOADING(false)
      }
      this.getSignTimes()
      switch (Number(this.totalNumber)) {
        case 1:
          this.$refs.dialog.showDialog('signDay_1')
          break;
        case 2:
          this.$refs.dialog.showDialog('signDay_2')
          break;
        case 3:
          this.$refs.dialog.showDialog('signDay_3')
          break;
        case 4:
          this.$refs.dialog.showDialog('signDay_4')
          break;
        case 5:
          this.$refs.dialog.showDialog('signDay_5')
          break;
        default:
          this.$refs.dialog.showDialog('signDay_6')
          break;
      }
      this.signClickFlag = false
    },
    // 刷新可领取礼包列表
    refreshGiftList() {
      this.getGiftList()
    },
    // 点击跳到抽奖转盘
    goToDown() {
      this.$refs.scroll.scrollToElement(document.querySelector('#lottery'))
    },
    // 跳转到签到部分
    scrollToSign() {
      this.$refs.scroll.scrollToElement(document.querySelector('#sign'))
    }
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/_variable';
@import '~@/styles/mixins.scss';
.wrapper {
  width: 100%;
  height: 100vh;
  background-color: #ededed;
  .content {
    height: auto;
    padding-bottom: 20px;
  }
  .sign {
    width: 100%;
    height: 100vh;
    background-image: url('#{$cdn-url-hm}/sign_gift_act/01.png');
    background-size: cover;
    background-repeat: no-repeat;
    .sign-content {
      width: 100%;
      height: 100%;
      background-image: url('#{$cdn-url-hm}/sign_gift_act/02.png');
      background-size: contain;
      background-repeat: no-repeat;
      .account {
        position: relative;
        top: 10px;
        left: 10px;
        font-size: 12px;
        span {
          color: red;
        }
      }
      .sign-gift {
        position: relative;
        top: 305px;
        width: 100%;
        height: 285px;
        display: flex;
        flex-direction: column;
        align-items: center;
        > p {
          font-size: 14;
          color: #f97a00;
        }
        .btn-wrapper {
          margin-top: 9px;
          width: 100%;
          height: 68px;
          text-align: center;
          > img {
            width: 130px;
          }
          > img:first-child {
            margin-right: 10px;
          }
        }
        .sign-rule {
          margin-top: 10px;
          height: 60px;
          line-height: 23px;
          font-size: 14px;
          text-align: center;
          > p:first-child {
            color: #ffb428;
          }
        }
        .down {
          margin-top: 50px;
          width: 30px;
        }
      }
    }
  }
  .gift {
    margin-top: 8px;
    .no-bind {
      position: relative;
      margin-top: 8px;
      > p {
        line-height: 20px;
        text-align: center;
        font-size: 12px;
        color: #d1d1d1;
      }
      > div {
        position: absolute;
        top: 30px;
        left: 50%;
        width: 100px;
        height: 25px;
        border: 1px solid rgba(69, 175, 243, 1);
        border-radius: 12px;
        font-size: 10px;
        color: rgba(69, 175, 243, 1);
        line-height: 25px;
        text-align: center;
        transform: translateX(-50%);
      }
      > img {
        width: 301px;
        margin: 14px 0px 0px 16px;
      }
    }
  }
  .rules {
    margin-top: 5px;
    padding: 8px 0 15px 0;
    font-size: 10px;
    line-height: 16px;
  }
}
</style>